import React from 'react'
import I18n from 'lib/i18n'

export default function Guest () {
  return (
    <div className='content-page media-page'>
      <div className='row'>
        <div className='twelve columns'>
          <div className='widget noborder slider-box content-box equal clearfix' style={{ marginBottom: 70 }}>
            <img
              className='retina page-header retina-off'
              data-retina='/assets/pages/about/piano@2x.png'
              height='360'
              src='/assets/pages/about/piano.png'
              style={{ marginBottom: 40 }}
              width='840'
            />
            <div className='start-part clearfix' style={{ textAlign: 'center' }}>
              <a className='button' href='/en/login' rel='nofollow'>
                {I18n.t('pages.invite.login')}
              </a>
              <a href='/en/signup?reg_type=invite' rel='nofollow'>
                {I18n.t('pages.invite.signup')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
